/* eslint-disable @typescript-eslint/no-explicit-any */
import { useFetch2 } from "../util";

interface Header {
  key: string | null;
  value: string | null;
}

export interface IWebHookConfig {
  url: string | null;
  headers: Header[] | null;
  transferUrl: string | null;
  sendMessageUrl: string | null;
  closeRoomUrl: string | null;
  callbackUrl: string | null;
  digitalEmployeeUrl: string | null;
  digitalEmployeeCallbackUrl: string | null;
  digitalEmployeeSendHistory: boolean;
  digitalEmployeeMemoryExpirationMinutes: number | null;
  digitalEmployeeHistorySize: number | null;
}

const WebhookServices = () => {
  const fetch = useFetch2();
  const getWebhookConfig = (id: number): Promise<IWebHookConfig> => {
    return fetch(`/api/bots/${id}/webhook-config`, { method: "GET" });
  };

  const postWebhookConfig = async (id: number, data: IWebHookConfig) => {
    try {
      const method = { method: "POST" };
      return await fetch(`/api/bots/${id}/webhook-config`, method, data);
    } catch (error) {
      return error;
    }
  };

  return {
    getWebhookConfig,
    postWebhookConfig
  };
};

export default WebhookServices;
